import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';

import messages from './CurrentReportView.intl';

import ArticleDetail from 'common/components/ArtricleDetailPage/ArticleDetailPage';

import { ANCHOR } from 'common/consts/common';

import LanguageService from 'services/Language.service';
import CurrentReportsStore from 'stores/CurrentReports.store';
import ContentStore from 'stores/Content.store';
import Location from 'stores/Location.store';

@injectIntl
@withRouter
@observer
export default class CurrentReportView extends Component {
  state = {
    article: null
  };

  async getArticle(slug) {
    const availableLanguages = LanguageService.getSortedLanguages();

    let article = await availableLanguages.reduce(
      (previousPromise, nextLang) => {
        return previousPromise.then(
          result =>
            result ||
            CurrentReportsStore.getCurrentReportsItemBySlug(slug, nextLang)
        );
      },
      Promise.resolve()
    );

    if (article) {
      if (LanguageService.getLang() !== article.system.language) {
        article = await CurrentReportsStore.getCurrentReportsItemById(
          article.id
        );
      }
    }
    LanguageService.adjustSlugToLanguage(this, article);

    article
      ? this.setState({ article })
      : this.props.history.push(
          `${ANCHOR.CURRENT_REPORTS[LanguageService.getLang()]}`
        );
  }

  contactPerson = {};

  async componentDidMount() {
    reaction(
      () => ContentStore.isLoaded,
      () => {
        this.contactPerson = ContentStore.content
          ? ContentStore.content.pressRoomContactPerson
          : {};
      },
      {
        fireImmediately: true
      }
    );
    let articleSlug = this.props.match.params.slug;

    this.getArticle(articleSlug);
  }

  didComeFromListing() {
    const lastPath = Location.getLastLocation();
    return lastPath && lastPath.pathname === ANCHOR.CURRENT_REPORTS;
  }

  render() {
    const { article } = this.state;

    return (
      <ArticleDetail
        messages={messages}
        didComeFromListing={this.didComeFromListing}
        article={article}
        viewWithOnlyArticle
        defaultPreviousPath={ANCHOR.CURRENT_REPORTS}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CurrentReport/CurrentReportView.js